export default "__VITE_PUBLIC_ASSET__ebc1ad0a__"